import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api/index.js';
import { notification } from 'antd';

const handleError = (message) => {
    notification.error({
        message: 'Error',
        description: message || 'Server error',
    });
};

export const fetchSettings = createAsyncThunk('settings/fetchAll', async (_, { rejectWithValue }) => {
    try {
        const response = await API.settings.get();
        return response;
    } catch (error) {
        handleError(error.message);
        return rejectWithValue(error.message);
    }
});

export const createSetting = createAsyncThunk('settings/create', async ({ data }, { rejectWithValue }) => {
    try {
        const settings = await API.settings.create({ setting: data });
        return settings;
    } catch (error) {
        handleError(error.message);
        return rejectWithValue(error.message);
    }
});

export const updateSetting = createAsyncThunk('settings/update', async ({ data }, { rejectWithValue }) => {
    try {
        const settings = await API.settings.update({ setting: data });
        return settings;
    } catch (error) {
        handleError(error.message);
        return rejectWithValue(error.message);
    }
});

export const deleteSetting = createAsyncThunk('settings/delete', async ({ key }, { rejectWithValue }) => {
    try {
        const settings = await API.settings.delete(key);
        return settings;
    } catch (error) {
        handleError(error.message);
        return rejectWithValue(error.message);
    }
});
